import { render, staticRenderFns } from "./BaseSmsCaptcha.vue?vue&type=template&id=d2123246&scoped=true&"
import script from "./BaseSmsCaptcha.vue?vue&type=script&lang=js&"
export * from "./BaseSmsCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./BaseSmsCaptcha.vue?vue&type=style&index=0&id=d2123246&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2123246",
  null
  
)

export default component.exports